
export default class GetSubcontractorContractsRequest {
    
    public excludeWarehouseId: string | null = null;
    
    public excludeConstructionSiteId: string | null = null;
}